
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import EventGuests from '@/modules/user/events/_components/EventGuests.vue';
  import EventDetails from '@/modules/user/events/_components/EventDetails.vue';

  @Component({
    components: {
      EventGuests,
      EventDetails,
    },
  })
  export default class VEventDetails extends Vue {
    public $refs!: {
      form: any,
    };

    @Prop({type: String, default: ''}) private id!: string;

    @Action('user/events/readOne') private readOne!: (params: any) => Promise<any>;

    @Action('common/loader/start') private start!: () => Promise<any>;
    @Action('common/loader/stop') private stop!: () => Promise<any>;

    @Getter('user/events/one') private event!: any;

    private loading: boolean = false;
    private text: string = '';
    private valid: boolean = true;
    private localEvent: any = null;

    private mounted() {
      return this.init();
    }

    private async init() {
      this.start();
      this.loading = true;
      await this.readOne({id: this.id});

      this.localEvent = this.event;
      this.loading = false;
      this.stop();
    }
  }
